import React, {useCallback, useState} from 'react';
import {StyledLabel, StyledTextDiv} from '../TextDivWithLabel/styled';
import {StyledInput} from './styled';

interface TextDivWithLabelEditableProps {
    text: string;
    label?: string;
    onEdit: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextDivWithLabelEditable: React.FC<TextDivWithLabelEditableProps> = ({
	label,
	text,
	onEdit,
}) => {
	const [editableText, setEditableText] = useState(text);

	const handleTextChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setEditableText(e.target.value);
		onEdit(e);
	}, [onEdit]);

	return (
		<>
			{label && <StyledLabel>{label}</StyledLabel>}
			<StyledTextDiv>
				<StyledInput
					type="text"
					value={editableText}
					onChange={handleTextChange}
				/>
			</StyledTextDiv>
		</>
	);
}

export default TextDivWithLabelEditable;
